import {api, routes} from "@/plugins/axios";

export function useDocuments() {
    const createFolder = async (organizationSlug, data) => {
        try {
            const response = await api.post(routes.documents.folder.create(organizationSlug), data);
            return Promise.resolve(response.data);
        } catch (e) {
            console.error(e);
            return Promise.reject(e);
        }
    }

    const createFile = async (organizationSlug, data) => {
        try {
            const response = await api.post(routes.documents.document.create(organizationSlug), data);
            return Promise.resolve(response.data);
        } catch (e) {
            console.error(e);
            return Promise.reject(e);
        }
    }

    const list = async (organizationSlug, currentPage, perPage, search, sortBy, folderUid) => {
        try {
            const response = await api.get(routes.documents.list(organizationSlug, currentPage, perPage, search, sortBy, folderUid));
            return Promise.resolve(response.data);
        } catch (e) {
            console.error(e);
            return Promise.reject(e);
        }
    }

    const showFolder = async (organizationSlug, folderUid) => {
        try {
            const response = await api.get(routes.documents.folder.show(organizationSlug, folderUid));
            return Promise.resolve(response.data);
        } catch (e) {
            console.error(e);
            return Promise.reject(e);
        }
    }

    const showFile = async (organizationSlug, documentableUid) => {
        try {
            const response = await api.get(routes.documents.document.show(organizationSlug, documentableUid));
            return Promise.resolve(response.data);
        } catch (e) {
            console.error(e);
            return Promise.reject(e);
        }
    }

    const addToFavorite = (organizationSlug, documentUid) => {
        return api.post(routes.documents.like(organizationSlug, documentUid))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const removeFromFavorite = (organizationSlug, documentUid) => {
        return api.delete(routes.documents.unlike(organizationSlug, documentUid))
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const deleteDocuments = (organizationSlug, documentUid) => {
        return api.post(routes.documents.delete(organizationSlug), documentUid)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const shareDocuments = (organizationSlug, documentUid, payload) => {
        return api.post(routes.documents.share(organizationSlug, documentUid), payload)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    const moveDocuments = (organizationSlug, payload) => {
        return api.post(routes.documents.move(organizationSlug), payload)
            .then((response) => {
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

    return {
        createFolder,
        showFolder,
        showFile,
        createFile,
        list,
        addToFavorite,
        removeFromFavorite,
        deleteDocuments,
        shareDocuments,
        moveDocuments
    }
}